(function($) {

	'use strict';

	var init = function() {
        if($('body.home').length == 1){
        	initHome();
        }
	};

	var initHome = function() {
        
        $('.contain-testimony .testimonies').addClass('owl-carousel');
        $('.contain-testimony .testimonies').addClass('owl-theme');
        $('.contain-testimony .testimonies').owlCarousel({
            items: 1,
//            dots: true,
            loop:true,
//            dotsEach:true,
            autoplay: false
//            autoplayTimeout: 5000,
//            autoplaySpeed: 1500
        });
        
        $('.arrow-scroll').on('click', function(e){
            $('html, body').animate({
                scrollTop: $('.contain-hightlight-trip').offset().top
            }, 1000);
        });
        
        var mappath = $('.mappath').attr('value');
        $('.contain-head-page__text__travel-choice .oneitem').on('mouseover', function(e){
            if($(this).hasClass('frmap')){
                $('.contain-head-page__text__travel-choice .smallmap').addClass('frmap');
                $('.contain-head-page__text__travel-choice .smallmap').removeClass('eumap');
                $('.contain-head-page__text__travel-choice .smallmap').removeClass('womap');
                $('.contain-head-page__text__travel-choice .smallmap img').attr('src', mappath+'map_france.svg');
            }
            if($(this).hasClass('eumap')){
                $('.contain-head-page__text__travel-choice .smallmap').removeClass('frmap');
                $('.contain-head-page__text__travel-choice .smallmap').addClass('eumap');
                $('.contain-head-page__text__travel-choice .smallmap').removeClass('womap');
                $('.contain-head-page__text__travel-choice .smallmap img').attr('src', mappath+'map_europe.svg');
            }
            if($(this).hasClass('womap')){
                $('.contain-head-page__text__travel-choice .smallmap').removeClass('frmap');
                $('.contain-head-page__text__travel-choice .smallmap').removeClass('eumap');
                $('.contain-head-page__text__travel-choice .smallmap').addClass('womap');
                $('.contain-head-page__text__travel-choice .smallmap img').attr('src', mappath+'map_world.svg');
            }
        });
	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
